import request from '../../utils/request';
import { fileService } from "@/api/common/file-utils";

export const apiService = {
    search: (data) => {
        return request({
            url: '/supplier-mark/getList',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    deleteByIds: (data) => {
        return request({
            url: '/supplier-mark/deleteByIds',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getById: (data) => {
        return request({
            url: '/supplier-mark/getSupplierMarkDetai/' + data,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    //评分管理保存.发布评分
    toAddSupplierMark: (data) => {
        return request({
            url: '/supplier-mark/toAddSupplierMark',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //评分管理保存.发布评分
    getSupplierMarkDetai: (data) => {
        return request({
            url: '/supplier-mark/getSupplierMarkDetai/' + data,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    //保存评分
    toSubmitMark: (data) => {
        return request({
            url: '/supplier-mark/toSubmitMark',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //保存评分
    countUnSubmitSuppliers: (spmId) => {
        return request({
            url: `/supplier-mark/countUnSubmitSuppliers?spmId=${spmId}`,
            method: 'get',
        })
    },
    //供应商评分分享
    shareMark: (data) => {
        return request({
            url: '/supplier-mark/ShareMark',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //Category1 Category2
    findCategory: (data) => {
        return request({
            url: '/category/findCategory',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    markDownload: (id) => request({
        url: 'supplier-mark/markDownload/' + id,
        method: 'get',
        fullResponse: true,
        responseType: 'blob'
    }).then(resp => {
        fileService.respToFile(resp);
    }),
    download: (data) => {
        return request({
            url: `supplier-mark/markDownload`,
            method: 'post',
            data: data,
            responseType: 'blob',
            fullResponse: true
        }).then(fileService.respToFile);
    },
    revoke(ids,msg) {
        return request({
            url: '/supplier-mark/revoke',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: {
                supplierMarkSupplierIds:ids,
                msg: msg
            }
        })
    }
}